const apiConfig = {
  // API Base URL
  // apiBaseURL: "http://localhost:4450",
  
  apiBaseURL: "https://devadminapi.giftsfromheaven.com",

  // apiBaseURL: "https://stagingadminapi.giftsfromheaven.com"
};

export default apiConfig;